<template>
  <v-alert
    v-if="text"
    dense
    text
    :type="type"
    :icon="icon"
    :class="alertClass"
  >
    <span class="font-weight-medium">{{ text }}</span>
  </v-alert>
</template>

<script>
export default {
  name: "InfoHint",
  props: {
    text: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: "info"
    },
    icon: {
      type: String,
      default: "mdi-lightbulb-on-outline"
    },
    alertClass: {
      type: String,
      default: "mt-2"
    }
  }
}
</script>
